import React from 'react'

const IconFacebook: React.FC = () => {
  return (
    <img src="/fb.png" width={20} height={20}></img>
  )
}

export default IconFacebook
